import { useCallback, useMemo } from 'react';

interface Section {
  id: string;
  name: string;
  options: SettingsOption[];
}

export interface SettingsOption {
  id: string;
}

const sections: Section[] = [
  {
    id: 'account',
    name: 'Account',
    options: [
      {
        id: 'stores',
      },
      {
        id: 'my-account',
      },
      {
        id: 'preferences',
      },
      {
        id: 'billing',
      },
    ],
  },
  {
    id: 'business',
    name: 'Business',
    options: [
      {
        id: 'permissions',
      },
    ],
  },
];

const allOptions = sections.flatMap((section) => section.options);

const useOrgSettingOptions = () => {
  const getOption = useCallback((id: string | undefined) => {
    if (id == null) {
      return undefined;
    }
    return allOptions.find((option) => option.id === id);
  }, []);

  return useMemo(() => ({ getOption, sections, allOptions }), [getOption]);
};

export default useOrgSettingOptions;
